import { InjectionToken } from '@angular/core';

export const ANALYTICS_ESSENTIAL_EVENTS = new InjectionToken<string[]>('anlyticsEssentialEventsInjectionToken');
